import React from "react";
import { Link } from "react-router-dom";
import { mediaUrl, fmt } from "../lib/api";

const catLabel = { ebooks: "E-Book", templates: "Template", courses: "Course", bundles: "Bundle" };

export const ProductCard = ({ product, index = 0 }) => {
  return (
    <Link
      to={`/p/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group vm-glass rounded-xl overflow-hidden shadow-sm transition-transform duration-300 hover:-translate-y-1.5 hover:border-white/25 vm-fade-up flex flex-col"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-zinc-900">
        <img
          src={mediaUrl(product.cover_path)}
          alt={product.title}
          className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
        />
        <span className="absolute top-3 left-3 text-[10px] tracking-[0.18em] uppercase px-2.5 py-1 rounded-full bg-black/70 backdrop-blur border border-white/15 text-zinc-200">
          {catLabel[product.category]}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-head text-lg font-medium tracking-tight leading-snug">{product.title}</h3>
        <p className="text-sm text-zinc-400 mt-2 line-clamp-2 font-light flex-1">{product.description}</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="font-mono text-base text-white">{fmt(product.price)}</span>
          <span className="text-xs text-zinc-500 group-hover:text-white transition-colors">View →</span>
        </div>
      </div>
    </Link>
  );
};
